import { VacancyLayoutVersion } from './VacancyEnums';

export interface CompanyVacancyLayoutModel {
  company_id: string;
  layout: VacancyLayoutVersion;
}
